/**
 * Created by rathompson on 10/20/21
 * File: Sidebar
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { VFC, useMemo } from 'react'
import {
  Body,
  SuccessIcon,
} from '@panwds/react-ui'
import {
  LABEL_OPTIONAL,
} from '../../../../constants/LabelConstants'
import Tab from './Tab'

/**
 *   Sidebar specific to the add modal
 */
const Sidebar: VFC<{
  options: any[],
  currentOption: { name: string } | null,
  onTabClick?: Function
}> = ({ options = [], currentOption, onTabClick }) => {

  const tabs = useMemo(() => {
    return options
      .sort((a, b) => (a?.index || 0) - (b?.index || 0))
      .map((tab, index) => {
        const { name, optional, icon } = tab
        return (
          <Tab
            key={index}
            selected={currentOption?.name === name}
            onClick={onTabClick ? onTabClick.bind(this, tab) : null}
          >
            <span className="tw-flex tw-items-baseline tw-gap-1">
              {name}{optional && <Body size="sm">{LABEL_OPTIONAL}</Body>}
            </span>
            {icon && <SuccessIcon size='sm' />}
          </Tab>
        )
      })
  }, [currentOption, onTabClick, options])

  return (
    <div id="add-sidebar" className="tw-bg-gray-100 dark:cm-bg-gray-1050 tw-whitespace-nowrap" style={{ minWidth: '200px' }}>
      {tabs}
    </div>
  )
}

export default Sidebar
